import { useQuery } from '@tanstack/react-query';
import {
  vouchersService,
  FetchVoucherBrandsParams,
  FetchVoucherBrandsResponse,
} from '@aslanpay/portal-common-lib';

const DEFAULT_PAGE_SIZE = 500;

export function useFetchVoucherBrands(params?: FetchVoucherBrandsParams) {
  return useQuery<FetchVoucherBrandsResponse, Error>(
    ['fetchVoucherBrands', params],
    () =>
      vouchersService.fetchVoucherBrands({
        providers: ['SPENDSTREAM'],
        page: 0,
        size: DEFAULT_PAGE_SIZE,
        ...params, // overrides default values if caller passes custom ones
      }),
    {
      keepPreviousData: true,
    }
  );
}

export default useFetchVoucherBrands;
